import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-fullWidth-wrapper',
  template: `
    <div class="fullWidthComponent">
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullWidthWrapperComponent extends FieldWrapper {}
